var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import { CalenderOutlined, WrongFilled } from '@feb-team/legao-icons-react';
import { defaultProps } from './defaults';
import { DivTag, SpanTag } from '../../Utils/AtomicTag';
import { formatDate, formatDateTime } from '@feb-team/data-logic';
import { inputDateParseDate, stringParseInputDateValue } from './utils';
import { Calendar } from './Calendar';
var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.componentWillReceiveProps = function (nextProps) {
            _this.setState(Object.assign(_this.state, _this.initData(nextProps)));
            _this.isOpen(nextProps);
        };
        /**
         * 初始化数据
         * @param props
         */
        _this.initData = function (props) {
            var type = props.type, defaultValue = props.defaultValue, value = props.value, format = props.format, isOpenPanel = props.isOpenPanel;
            var chooseValue = value || defaultValue;
            var formatDateValue = inputDateParseDate(chooseValue);
            if (!chooseValue || !formatDateValue) {
                return {
                    inpValStr: '',
                    value: '',
                    valueDate: '',
                };
            }
            var formatValue = /datetime/.test(type)
                ? formatDateTime(formatDateValue, format)
                : formatDate(formatDateValue, format);
            return {
                inpValStr: formatValue,
                value: formatValue,
                valueDate: formatDateValue,
                valueType: typeof chooseValue,
            };
        };
        /**
         * 是否打开弹窗
         * @param props
         */
        _this.isOpen = function (props) {
            if (props.isOpenPanel) {
                _this.inputEl.focus();
                _this.handerInputClick();
            }
            else {
                if (_this.state.isOpenPanel) {
                    _this.setState({
                        isOpenPanel: false,
                    });
                }
            }
        };
        /**
         * 选择日期处理函数
         * @param value
         */
        _this.onChange = function (e, value) {
            var _a = _this.props, onChange = _a.onChange, onBeforeChange = _a.onBeforeChange, type = _a.type, rangeIdx = _a.rangeIdx, defaultRangeValue = _a.defaultRangeValue, format = _a.format;
            var inputDateValue = stringParseInputDateValue(value, _this.state.valueType);
            if (onBeforeChange(inputDateValue, e)) {
                var valueCache = new Date(value.replace(/\-/g, '/'));
                var formatValue = /time/.test(type)
                    ? formatDateTime(valueCache, format)
                    : formatDate(valueCache, format);
                _this.setState({
                    inpValStr: formatValue,
                    value: formatValue,
                    valueDate: valueCache,
                    isOpenPanel: false,
                }, function () {
                    onChange(inputDateValue, e);
                });
            }
        };
        /**
         * 输入框点击
         */
        _this.handerInputClick = function () {
            if (_this.state.isOpenPanel || _this.props.disabled) {
                return false;
            }
            _this.setState({
                isOpenPanel: true,
            });
        };
        /**
         * 输入框失去焦点
         * @param e
         */
        _this.handerInputBlur = function (e) {
            _this.setState({
                isOpenPanel: false,
            }, function () {
                if (_this.props.rangeIdx) {
                    _this.props.onClose();
                }
            });
        };
        /**
         * 鼠标进入
         */
        _this.onMouseEnter = function () {
            _this.setState({
                allowClear: true,
            });
        };
        /**
         * 鼠标离开
         */
        _this.onMouseLeave = function () {
            _this.setState({
                allowClear: false,
            });
        };
        /**清除 */
        _this.clearText = function (e) {
            _this.setState({
                value: '',
                inpValStr: '',
                valueDate: null,
            });
        };
        _this.state = Object.assign({
            inpValStr: '',
            value: '',
            isOpenPanel: false,
            valueDate: '',
            valueType: 'string',
            allowClear: false,
        }, _this.initData(props));
        return _this;
    }
    DatePicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, type = _a.type, disabled = _a.disabled, placeholder = _a.placeholder, bordered = _a.bordered, showIcon = _a.showIcon, className = _a.className, style = _a.style, hasConfirmBtn = _a.hasConfirmBtn, rangeIdx = _a.rangeIdx, reset = __rest(_a, ["type", "disabled", "placeholder", "bordered", "showIcon", "className", "style", "hasConfirmBtn", "rangeIdx"]);
        var _b = this.state, value = _b.value, valueDate = _b.valueDate, isOpenPanel = _b.isOpenPanel, allowClear = _b.allowClear;
        var contentCls = [
            'relative',
            'inline-flex',
            'rounded',
            'font-sans',
            'text-black',
            'text-xs',
            'border-gray-200',
            'border',
        ];
        var svgBoxCls = [
            'absolute',
            'right-0',
            'top-0',
            'mt-px-8',
            'mr-px-12',
            'w-px-14',
            'fill-black',
            'opacity-20',
        ];
        var selectCls = [
            'flex',
            'items-center',
            'justify-between',
            'cursor-pointer',
            'rounded',
        ];
        if (disabled) {
            contentCls.push('bg-gray-100', 'cursor-not-allowed');
            selectCls.push('cursor-not-allowed');
            svgBoxCls.push('cursor-not-allowed');
        }
        else {
            contentCls.push('bg-white', 'hover:border-brand-600');
        }
        if (isOpenPanel && !rangeIdx) {
            selectCls.push('shadow-input');
        }
        return (React.createElement(DivTag, { name: DatePicker.NAME, atomics: contentCls, className: className + " " + (rangeIdx ? 'legao-date-picker-range' : '') + " " + (isOpenPanel ? 'legao-date-picker-active' : ''), style: __assign({}, style) },
            React.createElement(DivTag, { atomics: selectCls, onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, autoPrefixedClassName: "date-picker-contain" },
                React.createElement("input", { readOnly: true, className: "date-picker-input rounded " + (disabled ? 'date-picker-cursor-not-allowed' : 'date-picker-cursor-pointer'), type: "text", placeholder: placeholder, onClick: function () { return _this.handerInputClick(); }, onBlur: function (e) { return _this.handerInputBlur(e); }, value: value, disabled: disabled, ref: function (c) {
                        _this.inputEl = c;
                    } }),
                showIcon && (React.createElement(SpanTag, { atomics: svgBoxCls, autoPrefixedClassName: "date-picker-icon" }, !disabled && (allowClear || isOpenPanel) && value ? (React.createElement(WrongFilled, { onClick: function (e) { return _this.clearText(e); } })) : (React.createElement(CalenderOutlined, null))))),
            isOpenPanel && (React.createElement(Calendar, __assign({ type: type, hasConfirmBtn: /datetime/.test(type) ? true : hasConfirmBtn, formatValue: valueDate, onChoose: function (e, value) { return _this.onChange(e, value); }, rangeIdx: rangeIdx, isOpenPanel: isOpenPanel }, reset)))));
    };
    DatePicker.defaultProps = defaultProps;
    DatePicker.NAME = 'date-picker';
    DatePicker.displayName = 'DatePicker';
    return DatePicker;
}(Component));
export { DatePicker };
